import { render, staticRenderFns } from "./IconPosition.vue?vue&type=template&id=019bf6e6"
import script from "./IconPosition.vue?vue&type=script&lang=js"
export * from "./IconPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports